// DataTable.js
import React from "react";
// import '../../css/DataTable.css';

export default function DataTable({ 
  columns, 
  data, 
  sortConfig = {}, // مقدار پیش‌فرض اضافه شد
  onSort, 
  renderActions 
}) {
  const handleSort = (key) => {
    if (!onSort) return; // اگر onSort وجود ندارد، کاری نکن
    
    let direction = "asc";
    if (sortConfig && sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    onSort({ key, direction });
  };

  const getSortSymbol = (key) => {
    if (!sortConfig) return ""; // بررسی وجود sortConfig
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "▲" : "▼";
    }
    return "";
  };

  return (
    <table className="table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th 
              key={col.key} 
              onClick={() => col.key && handleSort(col.key)} // بررسی وجود col.key
              style={{ cursor: col.key ? "pointer" : "default" }}
            >
              {col.label} {col.key && getSortSymbol(col.key)}
            </th>
          ))}
          {renderActions && <th>عملیات</th>}
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
              {renderActions && <td>{renderActions(row)}</td>}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length + (renderActions ? 1 : 0)}>
              هیچ داده‌ای یافت نشد
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}